import { render, staticRenderFns } from "./MenuArchive.vue?vue&type=template&id=1bae4d19&scoped=true"
import script from "./MenuArchive.vue?vue&type=script&lang=js"
export * from "./MenuArchive.vue?vue&type=script&lang=js"
import style0 from "./MenuArchive.vue?vue&type=style&index=0&id=1bae4d19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bae4d19",
  null
  
)

export default component.exports